// extracted by mini-css-extract-plugin
module.exports = {"protector":"shared-components-ProtectionDiv-ProtectionDiv__protector--OEy0k"};